import { useEffect, useRef } from 'react'

export function useWakeLock() {
  const lockRef = useRef(null)

  async function acquire() {
    try {
      if ('wakeLock' in navigator) {
        lockRef.current = await navigator.wakeLock.request('screen')
      }
    } catch (_) { /* not supported or denied — silent */ }
  }

  useEffect(() => {
    acquire()
    const onVisibility = () => {
      if (document.visibilityState === 'visible') acquire()
    }
    document.addEventListener('visibilitychange', onVisibility)
    return () => {
      lockRef.current?.release().catch(() => {})
      document.removeEventListener('visibilitychange', onVisibility)
    }
  }, [])
}
